import React from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import useMarketShareHooks from 'src/components/AtlasV2Components/Hooks/useMarketShareRequestHook';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasV2SalesMarketShareProductSplineChart = () => {
  const { marketShareBuilder } = useMarketShareHooks();
  return (
    <AtlasV2ComparableSplineChart
      fieldName="retailSales"
      indexName="sales"
      metricTypeDisplay={METRICTYPE.PERCENT}
      title="Market Share of Retail Sales"
      marketShareBuilder={(rb) => marketShareBuilder(rb)}
    />
  );
};

export default AtlasV2SalesMarketShareProductSplineChart;
